import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory, useLocation } from 'react-router-dom';

import RequestList from './RequestsList';
import { REQUESTS } from '../Request';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import Message from '../../../../common/Message';

import { useMakeRequestStyles } from '../styles';

import { PURCHASE_ROUTE, TICKETS_ROUTE } from '../../../../../constants/Routes';

const MakeRequest = (props) => {
  const { mobile } = props;
  const location = useLocation();
  const history = useHistory();
  const classes = useMakeRequestStyles({ mobile });

  return (
    <React.Fragment>
      <ProfileTitle
        mobile={mobile}
        subtitle={
          <div>
            Aquí podrás realizar las solicitudes que necesites y luego podrás
            verlas reflejadas en{' '}
            <Link
              to={{
                pathname: TICKETS_ROUTE,
                state: { prevRoute: location.pathname },
              }}
              className={classes.link}
            >
              “Solicitudes de atención”.
            </Link>
          </div>
        }
        title={
          <strong>
            {mobile ? 'Realiza solicitud' : 'Realizar solicitud de atención'}
          </strong>
        }
      />
      <div className={classes.divMessage}>
        <Message
          severity="info"
          message={
            <div>
              Si tienes inconvenientes con tus productos, debes realizar un
              reporte en la sección{' '}
              <Link
                href="#"
                onClick={() => history.push(PURCHASE_ROUTE)}
                className={classes.goPurchases}
              >
                Compras realizadas
              </Link>
              .
            </div>
          }
          fullRounded
        />
      </div>
      <RequestList requests={REQUESTS} mobile={mobile} />
    </React.Fragment>
  );
};

MakeRequest.propTypes = {
  mobile: PropTypes.bool,
};

export default MakeRequest;
